import gql from "graphql-tag";

export const CUSTOMER_SIGNUP = gql`
  mutation customerSignUp($input: CustomerSignUpInput!) {
    customerSignUp(input: $input) {
      user {
        id
        email
      }
      errors {
        field
        message
      }
    }
  }
`;
